<template>
  <div class="discussion-item">
    <div class="discussion-item__title-box">
      <div class="discussion-item__icon-wrapper thread-comment__icon-wrapper">
        <span
          class="discussion-item__avatar-icon iconfont iprofile-icon"
        ></span>
      </div>
      <div>
        <div class="discussion-item__title-right thread-comment__name">
          <span class="thread-comment__username">{{
            thread.author.username
          }}</span>
          <span class="thread-comment__time">{{ thread.posted_time }}</span>
        </div>
        <h3 class="discussion-item__title">
          <div v-if="doc.isCommunityEOC">
            {{ thread.title }}
          </div>
          <router-link
            v-else
            :to="{
              name: doc.routeNames().thread,
              params: { thread: thread.url_slug },
            }"
          >
            {{ thread.title }}
          </router-link>
        </h3>
      </div>
    </div>
    <div class="discussion-item__flex-box">
      <div class="discussion-item__left-box">
        <div class="discussion-item__left">
          <div
            v-if="thread.comments_count !== 0"
            class="discussion-item__icon-link"
          >
            <div class="discussion-item__icon-box">
              <span class="discussion-item__icon iconfont ibubble"></span>
            </div>
            <p
              v-if="thread.comments_count === 1"
              class="discussion-item__left-text"
            >
              {{ thread.comments_count }} comment
            </p>
            <p v-else class="discussion-item__left-text">
              {{ thread.comments_count }} comments
            </p>
          </div>
        </div>
      </div>
      <div class="discussion-item__right-box">
        <p class="discussion-item__update discussion__hide-m">
          Updated {{ thread.last_active_time }}
        </p>
        <p class="discussion-item__update discussion__show-m">
          {{ thread.last_active_time }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ThreadView } from '@/models/forum'
import { DocView } from '@/models/doc'

defineProps<{
  thread: ThreadView
  doc: DocView
}>()
</script>
